namespace Matrix.Workflow {
    export interface WorkflowStatusRow {
        StatusCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace WorkflowStatusRow {
        export const idProperty = 'StatusCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Workflow.WorkflowStatus';
        export const lookupKey = 'Workflow.WorkflowStatus';

        export function getLookup(): Q.Lookup<WorkflowStatusRow> {
            return Q.getLookup<WorkflowStatusRow>('Workflow.WorkflowStatus');
        }
        export const deletePermission = 'DataAdmin:WorkflowStatus';
        export const insertPermission = 'DataAdmin:WorkflowStatus';
        export const readPermission = 'Read:WorkflowStatus';
        export const updatePermission = 'DataAdmin:WorkflowStatus';

        export declare const enum Fields {
            StatusCode = "StatusCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
